import { useAct } from 'FlowTaker/store'
import InlineEditableField from './InlineEditableField'
import SafeRenderHtml from "CampaignVolunteer/components/SafeRenderHtml"
import useActionTranslate from 'FlowBuilder/hooks/useActionTranslate'
import { ActionTranslatableKeys } from 'FlowBuilder/lib/actionTranslatable'

// A wrapper for InlineEditableField for action text content
// If html isn't passed then we just read the field from the text content

interface ActionTextContentFieldProps {
  actionId: number
  slug: ActionTranslatableKeys
  html?: string | null
  wysiwyg?: boolean
}

export default function ActionTextContentField({ actionId, slug, html = null, wysiwyg = true }: ActionTextContentFieldProps) {
  const act = useAct()
  const isPreview = useSel(s => s.local.isPreview)
  const { translated, fallback } = useActionTranslate({ actionId })
  const value = html || (isPreview ? translated[slug] : fallback[slug]) || ''

  const field = {
    wysiwyg,
    fieldKind: 'actionTextContent'
  }

  function handleClick(e) {
    act.taker.postMessageToParent('FIELD_EDIT_CLICK', { field, slug, actionId })
    e.stopPropagation();
  }

  if (isPreview) {
    return <InlineEditableField
      field={field}
      value={value}
      onClick={handleClick}
      translatable={true}
      defaultValue={fallback[slug] || null}
    />
  } else {
    return <SafeRenderHtml html={html || value} />
  }
}
